var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M995.25,503.03C995.25,227.93,773.52,4.92,500,4.92S4.75,227.93,4.75,503.03c0,248.62,181.1,454.69,417.87,492.06v-348.07h-125.75v-143.98h125.75v-109.74c0-124.84,73.94-193.79,187.06-193.79,54.19,0,110.86,9.73,110.86,9.73v122.58h-62.45c-61.52,0-80.71,38.4-80.71,77.79v93.43h137.35l-21.95,143.98h-115.4v348.07c236.76-37.37,417.87-243.43,417.87-492.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9b3d502af058bbbf53662d5404066a34.svg";
export { ForwardRef as ReactComponent };